module.exports = __webpack_public_path__ + "static/media/bottom-img-auth.f2b29b82.svg";